export default "__VITE_ASSET__BJpqbPC6__"